'use client';

import React from 'react';
import Image from 'next/image';

interface Props {
  onNext: () => void;
}

export default function StepWelcome({ onNext }: Props) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 max-w-sm mx-auto w-full gap-12">
      {/* Logo + name */}
      <div className="flex flex-col items-center gap-4 slide-up">
        <div className="relative w-24 h-24 flex items-center justify-center">
          <div className="absolute inset-0 rounded-3xl lavender-gradient opacity-20 blur-2xl scale-110" />
          <div className="relative w-20 h-20 rounded-3xl lavender-gradient flex items-center justify-center shadow-card overflow-hidden">
            <Image
              src="/assets/clingyai-logo.svg"
              alt="My Little Clingy logo"
              width={52}
              height={52}
              priority
              unoptimized
            />
          </div>
        </div>
        <span className="text-2xl font-extrabold text-foreground tracking-tight">My Little Clingy</span>
      </div>

      {/* Headline */}
      <div className="flex flex-col items-center gap-3 text-center slide-up" style={{ animationDelay: '100ms' }}>
        <h1 className="text-[34px] font-extrabold text-foreground leading-tight tracking-tight text-balance">
          A safe space,<br />
          <span className="text-primary">just for you.</span>
        </h1>
        <p className="text-[14px] text-muted-foreground leading-relaxed max-w-[220px]">
          Private. Warm. Always here when you need to talk.
        </p>
      </div>

      {/* CTA */}
      <div className="w-full slide-up" style={{ animationDelay: '200ms' }}>
        <button
          onClick={onNext}
          className="w-full py-4 rounded-2xl lavender-gradient text-white font-bold text-base shadow-card transition-all duration-200 active:scale-95 hover:shadow-lg"
        >
          I'm ready 🌿
        </button>
        <p className="text-center text-xs text-muted-foreground mt-4 leading-relaxed">
          No judgment. No pressure. Just a conversation.
        </p>
      </div>
    </div>
  );
}